import {
  isAfterToday,
  isBeforeToday,
  isToday,
} from '@/lib/daysjs-utils/is-today';
import { Deal } from '@/models/registry';
import type { DealListItem, RapidReconStep } from '@/models/types';

export const getDeliveryQueueHealth = ({
  pickupDateOrDeliveryDate,
  rapidReconStep,
}: {
  pickupDateOrDeliveryDate?: string;
  rapidReconStep?: RapidReconStep | null;
}): { isYellow: boolean; isRed: boolean; isGreen: boolean } => {
  if (rapidReconStep === 'Ready For Sale') {
    return {
      isYellow: false,
      isRed: false,
      isGreen: true,
    };
  }

  if (!pickupDateOrDeliveryDate) {
    return {
      isYellow: false,
      isRed: false,
      isGreen: false,
    };
  }

  return {
    isYellow: isToday(pickupDateOrDeliveryDate),
    isRed: isBeforeToday(pickupDateOrDeliveryDate),
    isGreen: isAfterToday(pickupDateOrDeliveryDate),
  };
};

export const getClassesFromHealth = ({
  isYellow,
  isRed,
  isGreen,
}: {
  isYellow: boolean;
  isRed: boolean;
  isGreen: boolean;
}) => {
  if (isRed) {
    return {
      'text-red-500': true,
      'text-yellow-500': false,
      'text-green-500': false,
    };
  }

  if (isYellow) {
    return {
      'text-yellow-500': true,
      'text-red-500': false,
      'text-green-500': false,
    };
  }

  if (isGreen) {
    return {
      'text-green-500': true,
      'text-yellow-500': false,
      'text-red-500': false,
    };
  }

  return {
    'text-green-500': false,
    'text-yellow-500': false,
    'text-red-500': false,
  };
};

const getDeliveryQueueHealthClasses = ({
  pickupDateOrDeliveryDate,
  deal,
}: {
  pickupDateOrDeliveryDate?: string | null;
  deal: Deal | DealListItem;
}): {
  'text-green-500'?: boolean;
  'text-yellow-500'?: boolean;
  'text-red-500'?: boolean;
} => {
  const dealRapidReconStep = deal?.rapid_recon_step;

  if (dealRapidReconStep === 'Ready For Sale') {
    return {
      'text-green-500': true,
      'text-yellow-500': false,
      'text-red-500': false,
    };
  }

  if (!pickupDateOrDeliveryDate) {
    return {
      'text-green-500': false,
      'text-yellow-500': false,
      'text-red-500': false,
    };
  }

  const { isYellow, isRed, isGreen } = getDeliveryQueueHealth({
    pickupDateOrDeliveryDate,
    rapidReconStep: dealRapidReconStep,
  });

  return getClassesFromHealth({
    isYellow,
    isRed,
    isGreen,
  });
};

export default getDeliveryQueueHealthClasses;
